import React, { Component } from 'react';
import Checkbox from './Checkbox';
import styled from 'styled-components';

const CheckboxComponent = styled.div`
    display: flex;
    &:hover{
        cursor: pointer;
    }
`;

const CheckboxLabel = styled.div`
    user-select: none;
`;

class CheckboxContainer extends Component {

    render() {
        return (<CheckboxComponent onClick={(i) => { this.props.handleClick(!this.props.checked) }}>
            <Checkbox handleClick={this.props.handleClick} checked={this.props.checked} indeterminate={this.props.indeterminate} />
            <CheckboxLabel onClick={(e) => { e.stopPropagation(); this.props.handleClick(!this.props.checked) }} >{this.props.label}</CheckboxLabel>
        </CheckboxComponent>);
    }
}

export default CheckboxContainer